import * as CryptoJS from 'crypto-js'

const shouldReplaceUrls = () => process.env.NODE_ENV !== 'development'

const encodePayload = payload =>
  CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(JSON.stringify(payload)))

const getEncodedPayload = (url, accessToken) => encodePayload({ url, accessToken })

const convertUrl = (url, accessToken) =>
  `${window.location.origin}/attachments/${getEncodedPayload(url, accessToken)}`

const replaceUrl = (attachment, accessToken) => ({
  ...attachment,
  url: convertUrl(attachment.url, accessToken),
})

export const replaceAttachmentUrls = (attachments, accessToken) => {
  return shouldReplaceUrls() ? attachments.map(a => replaceUrl(a, accessToken)) : attachments
}
